import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { DealTimelineEvent } from "@colab/shared";

// GET /api/portal/deals/:id/timeline
//
// Phase 7 sub-bucket 5 — derived from `deals.status_history` JSON. The
// service returns 404 for attribution-only rows; the SPA's read-only view
// omits the timeline panel when source='attribution' so this hook stays
// gated behind that branch.
//
// Known regression (per services/deals.ts comment): partner-submitted rows
// record `changed_by='system'` because createDealForPartner uses the admin
// client. The display layer renders missing actors as "System."
export function useDealStatusTimeline(id: string | null, enabled = true) {
  return useQuery<DealTimelineEvent[], ApiClientError>({
    queryKey: queryKeys.portal.deals.timeline(id ?? ""),
    queryFn: () =>
      apiFetch<DealTimelineEvent[]>(`/portal/deals/${id}/timeline`),
    enabled: !!id && enabled,
    // 404 is a normal outcome for attribution-only rows — don't retry.
    retry: false,
  });
}
